module.exports = __webpack_public_path__ + "img/stone-path-1.9b4ec199.png";